import { useLayoutEffect } from "react"

import usePrefersReducedMotion from "../../../hooks/usePrefersReducedMotion"

// How long the page keeps its intro class: enough for the last element's delay and animation.
const INTRO_DURATION = 1500

// On page open, everything marked `data-intro` — the filter row, the block headings, the cards —
// fades up one after another, 45 ms apart (DAA-1-20); nothing moves with reduced motion. The
// animation itself is `introClassName`'s CSS.
export const useIntroMotion = (rootRef, introClassName) => {
  const prefersReducedMotion = usePrefersReducedMotion()

  // Before paint, so the cards never flash in place before they fade up.
  useLayoutEffect(() => {
    const root = rootRef.current

    if (!root || prefersReducedMotion) return undefined

    root.querySelectorAll("[data-intro]").forEach((element, index) => {
      element.style.setProperty("--intro-delay", `${Math.min(index, 14) * 45}ms`)
    })
    root.classList.add(introClassName)

    const timer = setTimeout(() => root.classList.remove(introClassName), INTRO_DURATION)

    return () => clearTimeout(timer)
    // Page open only: a later re-render must not replay it.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
